import styles from "./SettingsView.module.scss";
import { View, ViewHeader } from "@/components";

export const SettingsView = () => {
  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Settings"
          description="Manage preferences, configuration, and account-related options from one place.<br />Use this section to customize how the dashboard works for you."
        />
      </div>
    </View>
  );
};
